/**
 * tm/components/WMPortalModal.tsx — WM 관리 「포털」 미리 보기
 *  2026-10-29 지도사 「화면 달라진 거 없는데?」 — 이 창이 WM 포털을 따로 한 벌 더 그리고 있어서(357줄),
 *  WM 포털(/wm-portal/:id · WMPortalStandalone)을 고쳐도 여기는 옛 화면 그대로였다.
 *  → 진짜 WM 포털을 휴대폰 틀 안에 그대로 띄운다(한 벌만 고치면 미리 보기도 같이 바뀜)
 */
import { useEffect } from 'react';
import type { WM } from '../types';

export default function WMPortalModal({ wm, onClose }: { wm: WM; onClose: () => void }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  const src = `/wm-portal/${encodeURIComponent(wm.id)}`;
  return (
    <div role="dialog" aria-label={`${wm.name} WM 포털 미리 보기`} style={{ position: 'fixed', inset: 0, zIndex: 400 }}>
      <div onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.5)' }} />
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: 390, maxWidth: '94vw', height: '88vh', maxHeight: 820, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#fff', fontSize: 13 }}>
          <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{wm.name} WM님 화면 그대로</span>
          <button type="button" onClick={() => window.open(src, '_blank', 'noopener')} style={{ height: 28, padding: '0 10px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.5)', background: 'transparent', color: '#fff', fontSize: 12, cursor: 'pointer' }}>새 창</button>
          <button type="button" onClick={onClose} aria-label="닫기" style={{ height: 28, width: 28, borderRadius: 8, border: 'none', background: 'rgba(255,255,255,0.2)', color: '#fff', fontSize: 14, cursor: 'pointer' }}>✕</button>
        </div>
        <div style={{ flex: 1, minHeight: 0, background: '#fff', borderRadius: 28, overflow: 'hidden', border: '4px solid #e5e7eb', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
          <iframe title={`${wm.name} WM 포털`} src={src} style={{ width: '100%', height: '100%', border: 'none', display: 'block' }} />
        </div>
      </div>
    </div>
  );
}
